<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media w-100">
      <div class="media-body text-center">
        <span>{{ username }}</span>
      </div>

      <!-- Show icon when no image or still loading (we use imageLoaded) -->
      <div v-if="!profileImage || !imageLoaded"
        class="rounded-circle d-flex align-items-center justify-content-center border"
        style="width: 48px; height: 48px;">
        <i class="pi pi-user text-secondary" style="font-size: 1.75rem;"></i>
      </div>

      <!-- Show profile image only when preloader says it's good -->
      <img v-else :src="profileImage" alt="Profile" class="rounded-circle border"
        style="width: 48px; height: 48px; object-fit: contain;" />
    </div>

    <ul class="profile-dropdown onhover-show-div">
      <li class="dropdown-item logout-item" @click="logout">
        <vue-feather type="log-in" class="logout-icon" />
        <span>Log out</span>
      </li>
    </ul>
  </li>
</template>

<script>
import { removeCookies, getCookies } from "../../utils";
import 'primeicons/primeicons.css'

export default {
  name: "Profile",
  data() {
    return {
      username: "",
      profileImage: "",
      isLoading: false,     // optional/useful for other logic
      imageLoaded: false,   // shows when preloader succeeded
      _preloadImg: null,    // internal reference to cancel if needed
    }
  },
  watch: {
    profileImage(newVal) {
      // If there's no URL, ensure flags are reset
      if (!newVal) {
        // cancel previous preloader if any
        if (this._preloadImg) {
          this._preloadImg.onload = null;
          this._preloadImg.onerror = null;
          this._preloadImg = null;
        }
        this.isLoading = false;
        this.imageLoaded = false;
        return;
      }

      // start preload
      this.isLoading = true;
      this.imageLoaded = false;

      // cancel any previous preloader handlers
      if (this._preloadImg) {
        this._preloadImg.onload = null;
        this._preloadImg.onerror = null;
      }

      const img = new Image();
      this._preloadImg = img;

      img.onload = () => {
        // ensure this handler is for the latest preload
        if (this._preloadImg !== img) return;
        this.isLoading = false;
        this.imageLoaded = true;
        this._preloadImg = null;
      };

      img.onerror = () => {
        if (this._preloadImg !== img) return;
        this.isLoading = false;
        this.imageLoaded = false;
        // fallback to default icon
        this.profileImage = '';
        this._preloadImg = null;
      };

      // start actual loading
      img.src = newVal;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("User");
      sessionStorage.removeItem("token");
      removeCookies("token", "");
      removeCookies("session", "");
      this.$router.replace("/auth/login");
    },
  },
  mounted() {
    const payload = getCookies("token").split(".")[1];
    const decoded = JSON.parse(atob(payload));

    if (decoded?.ProfilePicture) {
      this.profileImage = decoded.ProfilePicture; // triggers watch -> preload
    }
    this.username = decoded.Name;
  },
  beforeUnmount() {
    // cleanup any pending preload handlers
    if (this._preloadImg) {
      this._preloadImg.onload = null;
      this._preloadImg.onerror = null;
      this._preloadImg = null;
    }
  }
};
</script>


<style scoped>
::v-deep(.onhover-show-div) {
  transition: all 0.5s ease-out !important;
  /* override from external package */
}

.profile-img {
  width: 48px;
  height: 48px;
  border: 2px solid #218863;
  padding: 2px;
  object-fit: contain;
}

.profile-dropdown {
  list-style: none;
  margin: 0;
  padding: 0;
}

.profile-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.profile-dropdown .dropdown-item:hover {
  background-color: #f0f0f0;
}

.logout-icon {
  margin-right: 10px;
}

.profile-nav {
  position: fixed;
  top: 0;
  z-index: 9999;

}
</style>
